package com.wintermar.inspection.feature.presentation.inspection.complete.widget.page_info

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.modal.ModalDialog

@Composable
actual fun PageInfoModal(
    show: Boolean,
    pages: List<String>,
    title: String,
    onDismiss: () -> Unit,
    onClick: (page: String) -> Unit
) {
    ModalDialog(
        title = title,
        show = show,
        onDismiss = onDismiss
    ) {
        PageInfo(
            pages = pages,
            onClick = onClick
        )
    }
}
